import React, { useContext, useEffect, useState } from "react";
import { Table } from "antd";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../context/AppContext";

const data = [
  {
    key: "1",
    caseID: "C001",
    clientName: {
      name: "John Doe",
      email: "john@example.com",
      phone: "(555) 123-4567",
    },
    evidenceType: "Digital (Email)",
    partyInfo: "Jane Doe (Opposing Party)",
    description: "Contract Dispute - C002",
  },
  {
    key: "2",
    caseID: "C001",
    clientName: {
      name: "Emily Davis",
      email: "emily@example.com",
      phone: "(555) 123-4567",
    },
    evidenceType: "Document",
    partyInfo: "XYZ Ltd. (Party in contract)",
    description: "Employment Contract - C003",
  },
  {
    key: "3",
    caseID: "C001",
    clientName: {
      name: "Michael Brown",
      email: "michael@example.com",
      phone: "(555) 123-4567",
    },
    evidenceType: "Video",
    partyInfo: "Smith Properties (Party in lease)",
    description: "Lease Agreement - C001",
  },
  {
    key: "4",
    caseID: "C001",
    clientName: {
      name: "Email Exchange.pdf",
      email: "john@example.com",
      phone: "(555) 123-4567",
    },
    evidenceType: "Digital (Email)",
    partyInfo: "Jane Doe (Opposing Party)",
    description: "Contract Dispute - C002",
  },
  {
    key: "5",
    caseID: "C001",
    clientName: {
      name: "Surveillance Footage.mp4",
      email: "john@example.com",
      phone: "(555) 123-4567",
    },
    evidenceType: "Video",
    partyInfo: "XYZ Ltd. (Party in contract)",
    description: "Employment Contract - C003",
  },
  {
    key: "6",
    caseID: "C001",
    clientName: {
      name: "Bank Records.pdf",
      email: "john@example.com",
      phone: "(555) 123-4567",
    },
    evidenceType: "Document",
    partyInfo: "Smith Properties (Party in lease)",
    description: "Lease Agreement - C001",
  },
];
const ClientTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(null);
  const [cases, setCases] = useState([]);
  const { allCases } = useContext(AppContext);
  
  const onDelClick = (caseId) => {
    setIsdelModalOpen(caseId);
  };
  const handleDetailsClick = (clientItem) => {
    
    console.log("Navigating with clientItem:", clientItem);
    navigate("/client/client-details",
    {
      state: { clientItem }
    }
    );
  };


  const columns = [
    {
      title: t("dashboard.clientInfoManagement.caseID"),
      dataIndex: "caseID",
      key: "caseID",
      render: (text) => (
        <p className="text-darkGrey small font-poppins">{text}</p>
      ),
    },
    {
      title: t("dashboard.clientInfoManagement.clientName"),
      dataIndex: "clientName",
      key: "clientName",
      render: (text) => (
        <div>
          <p className="text-darkGrey small font-poppins">{text}</p>
        </div>
      ),
    },
    {
      title: t("dashboard.clientInfoManagement.evidenceType"),
      dataIndex: "evidenceType",
      key: "evidenceType",
      render: (evidenceType) => (
        <div>
          <p className="text-darkGrey small font-poppins">{evidenceType}</p>
        </div>
      ),
    },
    {
      title: t("dashboard.clientInfoManagement.partyInfo"),
      dataIndex: "partyInfo",
      key: "partyInfo",
      render: (partyInfo) => (
        <p className="text-darkGrey small font-poppins">{partyInfo}</p>
      ),
    },
    {
      title: t("dashboard.clientInfoManagement.description"),
      dataIndex: "description",
      key: "description",
      render: (description) => (
        <p className="text-darkGrey small font-poppins">{description}</p>
      ),
    },
    {
      title: t("dashboard.clientInfoManagement.actions"),
      key: "actions",
      render: (_, record) => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => handleDetailsClick(record)}
            // onClick={() => {
            //   navigate("/client/client-details");
            // }}
          >
            {t("dashboard.clientInfoManagement.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={() => {
              onDelClick(record._id);
            }}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    console.log(allCases);
    const resultedData = allCases?.data?.map((item, index) => {
      return {
        key: index + 1,
        caseID: item.caseId || "N/A",
        clientName: item.client_name || "N/A",
        evidenceType:
          (item.type_of_evidence !== null && item?.type_of_evidence[0]) ||
          "N/A",
        partyInfo: item.party_info && item.party_info.length > 0 && item.party_info[0] || "N/A",
        description: item.description || "N/A",
        _id: item._id,
      };
    });
    console.log(allCases.data);
    setCases(resultedData);
  }, [allCases]);

  return (
    <>
      <Table
        columns={columns}
        dataSource={cases}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
      />
    </>
  );
};

export default ClientTable;
